import { render, staticRenderFns } from "./InventoriesInProductTable.vue?vue&type=template&id=742b096c&scoped=true&"
import script from "./InventoriesInProductTable.vue?vue&type=script&lang=js&"
export * from "./InventoriesInProductTable.vue?vue&type=script&lang=js&"
import style0 from "./InventoriesInProductTable.vue?vue&type=style&index=0&id=742b096c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "742b096c",
  null
  
)

export default component.exports